var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34734 14.5703L5.29273 14.2443C5.23049 14.0638 5.11787 13.9049 4.96819 13.7864L4.34734 14.5703ZM4.92686 16.2511L3.98148 16.577L4.92686 16.2511ZM6.40106 16.7739L5.87224 15.9251H5.87224L6.40106 16.7739ZM7.56289 16.05L7.7534 15.0683C7.50544 15.0202 7.24845 15.0677 7.03407 15.2012L7.56289 16.05ZM15.5 8.6875C15.5 12.2774 12.5899 15.1875 9 15.1875V17.1875C13.6944 17.1875 17.5 13.3819 17.5 8.6875H15.5ZM9 2.1875C12.5899 2.1875 15.5 5.09765 15.5 8.6875H17.5C17.5 3.99308 13.6944 0.1875 9 0.1875V2.1875ZM2.5 8.6875C2.5 5.09765 5.41015 2.1875 9 2.1875V0.1875C4.30558 0.1875 0.5 3.99308 0.5 8.6875H2.5ZM4.96819 13.7864C3.46281 12.5942 2.5 10.7536 2.5 8.6875H0.5C0.5 11.3904 1.76273 13.799 3.7265 15.3542L4.96819 13.7864ZM5.87224 15.9251L5.29273 14.2443L3.40196 14.8963L3.98148 16.577L5.87224 15.9251ZM5.87224 15.9251H5.87224L3.98148 16.577C4.40028 17.7917 5.83939 18.302 6.92988 17.6226L5.87224 15.9251ZM7.03407 15.2012L5.87224 15.9251L6.92988 17.6226L8.09171 16.8987L7.03407 15.2012ZM9 15.1875C8.57276 15.1875 8.15608 15.1464 7.7534 15.0683L7.37239 17.0316C7.89996 17.134 8.44421 17.1875 9 17.1875V15.1875Z",
    fill: "#303141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment_Icon.ce5e9711cff57963d99fa3e10fc855eb.svg";
export { ForwardRef as ReactComponent };